
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/skindiagnostic",
      function () {
        return require("private-next-pages/skindiagnostic/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/skindiagnostic"])
      });
    }
  